<template>
  <v-container fluid v-if="attendeesDetails">
    <material-card icon="mdi-google-classroom" title="Mark Attendance">
      <v-row>
        <v-col cols="3">Training Type : </v-col>
        <v-col cols="3">{{attendeesDetails.trainingData.type}}</v-col>
      </v-row>
      <v-row>
        <v-col cols="3">Training Title : </v-col>
        <v-col cols="3">{{attendeesDetails.trainingData.title}}</v-col>
      </v-row>
      <v-row>
        <v-col cols="3">Dates : </v-col>
        <v-col cols="3">From : {{formatDate(attendeesDetails.trainingData.fromDate)}}</v-col>
        <v-col cols="3">To : {{formatDate(attendeesDetails.trainingData.toDate)}}</v-col>
      </v-row>
      <v-row>
        <v-col cols="3">Time : </v-col>
        <v-col cols="3">From : {{attendeesDetails.trainingData.fromTime}}</v-col>
        <v-col cols="3">To : {{attendeesDetails.trainingData.toTime}}</v-col>
      </v-row>
      <v-row>
        <v-col cols="3">Trainer : </v-col>
        <v-col cols="3">
          <span v-for="(trainer, index) in attendeesDetails.trainingData.trainingTrainerMaps"
            :key="index">
            {{trainer.user.firstName +" " + trainer.user.lastName}}
            <span v-if="index+1 < attendeesDetails.trainingData.trainingTrainerMaps.length"> and </span>
          </span>
        </v-col>
      </v-row>
      <v-row>
        <v-col cols="3">Training Location : </v-col>
        <v-col cols="3">{{attendeesDetails.trainingData.trainingLocation ? attendeesDetails.trainingData.trainingLocation.companyName : 'NA'}}</v-col>
      </v-row>
      <v-row>
        <v-col cols="3">Batch Size : </v-col>
        <v-col cols="3">{{attendeesDetails.trainingData.batchSize}}</v-col>
      </v-row>
      <v-row>
        <v-col cols="3">Registration</v-col>
      </v-row>
      <v-row>
        <v-col cols="12">
          <v-row>
            <v-col cols="12">
              <v-data-table :headers="registrationtableHeaders" :items="getRegistrationDetails">

                <template v-slot:item.date="props">
                  <v-select :disabled="isDisable(props.header.text)" class="pl-2" :items="attendenceList"
                    v-model="attendanceTracker[props.item.id][props.header.text].isPresent">
                  </v-select>
                </template>
                <template v-slot:item.action="props">
                  <v-btn class="px-2 ml-1 white--text ma-1" outlined color="success" x-medium
                    @click="saveAttendence(props.item.id)">
                    Save
                  </v-btn>
                </template>
              </v-data-table>
            </v-col>
          </v-row>
        </v-col>
      </v-row>

      <v-row>
        <v-col cols="3">
          <router-link :to="{ name: 'AllTrainings' }">
            <v-btn class="px-2 ml-1 ma-1" min-width="0" small>Cancel</v-btn>
          </router-link>
        </v-col>
        <v-col cols="3">
          <v-btn class="px-2 ml-1 ma-1" @click="submitAttendence()" color="success" min-width="0"
            small>Submit
          </v-btn>
        </v-col>
      </v-row>
    </material-card>
  </v-container>
</template>
<script>
import constants from '@/utils/constants'
import MaterialCard from '@/components/template/MaterialCard'
// import Multiselect from 'vue-multiselect'
import moment from 'moment'
import _ from 'lodash'
// import _ from 'lodash'
export default {
  name: 'markAttendance',
  props: {
    trainingID: String
  },
  components: {
    MaterialCard
    // Multiselect
  },
  data () {
    return {
      attendanceTracker: {},
      attendeesDetails: null,
      trainingData: [],
      teacherName: [],
      registrationtableHeaders: [
        { text: 'Teacher Name', value: 'teacherName', sortable: false },
        { text: 'Center Name', value: 'centerName', sortable: false }
      ],
      attendenceList: [
        { text: 'Present', value: true, sortable: false },
        { text: 'Absent', value: false, sortable: false }
      ],
      trainingByTrainersEnrollments: '',
      selectedType: [],
      attendees: [
        {
          enrollmentID: '',
          isPresent: '',
          date: ''
        }
      ],
      isSubmit: false
    }
  },
  created: function () {
    this.getAttendeesDetails()
  },
  methods: {
    getAttendeesDetails: async function () {
      try {
        const { data } = await http.get(`${constants.API_URL}/api/teacher-training/get-attendees/${this.trainingID}`)
        this.attendeesDetails = data
        this.dateList = this.attendeesDetails.range // Dynamic date headers
        this.dateList.forEach((row) => {
          this.registrationtableHeaders.push({ text: row, value: 'date', align: 'center' })
        })
        this.registrationtableHeaders.push({ text: 'Action', value: 'action', sortable: false })
        this.getRegistrationDetails = this.attendeesDetails.trainingData.trainingByTrainersEnrollments
        this.getRegistrationDetails.forEach((row) => {
          row.teacherName = row.user.firstName + ' ' + row.user.lastName
          row.centerName = row.trainingByTrainerFranchiseeMap.franchisee.companyName
          // Creating attendance tracker with by default false
          this.attendanceTracker[row.id] = {}
          _.forEach(this.attendeesDetails.range, (date) => {
            this.attendanceTracker[row.id][date] = {
              enrollmentID: row.id,
              date: date,
              isPresent: '' // Unmarked attendace
            }
          })
          if (row.trainingAttendances) {
            // Updating attendance tracker with latest data
            _.forEach(row.trainingAttendances, (attendaceData) => {
              this.attendanceTracker[row.id][attendaceData.date].isPresent = attendaceData.isPresent
            })
          }
        })
      } catch (e) {
        const errorMessage = (e && e.response && e.response.data.message) || e.message
        this.errMsg(`Error While getting Data: ${errorMessage}`)
      }
    },
    formatDate (date) {
      return moment(date).format('DD/MM/YYYY')
    },
    isDisable (date) {
      let currentDate = moment()
      date = moment(date)
      if (currentDate.isSameOrAfter(date)) {
        return false
      } else {
        return true
      }
    },
    saveAttendence: async function (enrollmentID) {
      try {
        this.isLoading = true
        let attendees = []
        this.dateList.forEach(date => {
          // Ignoring unmarked attendance
          if (this.attendanceTracker[enrollmentID][date].isPresent !== '') {
            this.attendanceTracker[enrollmentID][date].date = moment(date).format('MM/DD/YYYY')
            attendees.push(this.attendanceTracker[enrollmentID][date])
          }
        })
        const data = {
          trainingID: this.trainingID,
          attendees: attendees
        }
        await http.post(`${constants.API_URL}/api/teacher-training/attendance-save`, data)
        this.okMsg('Attendence saved successfully!')
      } catch (e) {
        const errorMessage = (e && e.response && e.response.data.message) || e.message
        this.errMsg(errorMessage)
      } finally {
        this.isLoading = false
      }
    },
    submitAttendence: async function () {
      try {
        this.isLoading = true
        let attendees = []
        for (let enrollmentID of Object.keys(
          this.attendanceTracker
        )) {
          for (let date of this.dateList) {
            if (this.attendanceTracker[enrollmentID][date].isPresent !== '') {
              this.attendanceTracker[enrollmentID][date].date = moment(date).format('MM/DD/YYYY')
              attendees.push(this.attendanceTracker[enrollmentID][date])
            } else {
              return this.errMsg(`Please mark attendance for all teacher`)
            }
          }
        }

        const data = {
          trainingID: this.trainingID,
          attendees: attendees

        }
        await http.post(`${constants.API_URL}/api/teacher-training/attendance-submit`, data)
        this.okMsg('Attendence submitted successfully!')
        this.$router.push({ name: 'AllTrainings' })
      } catch (e) {
        const errorMessage = (e && e.response && e.response.data.message) || e.message
        this.errMsg(errorMessage)
      } finally {
        this.isLoading = false
      }
    },

    okMsg (msg) {
      return this.$dialog.info({
        title: 'Success',
        text: msg
      })
    },
    errMsg (msg) {
      return this.$dialog.error({
        text: msg,
        title: 'Error'
      })
    }
  }
}
</script>
<style src="vue-multiselect/dist/vue-multiselect.min.css"></style>
<style scoped>
#abcd {
  color: rgba(0, 0, 0, 0.6);
  font-size: 16px;
}
</style>
